const CONFERENCE_IMAGE_PATH = '/assets/three_d_studio/conference_sign_in_modal'
const AI_IMAGE_PATH = '/assets/three_d_studio/ai_sign_in_modal'

export const GALLERY_IMAGES = [
  {
    name: 'drone',
    src: `${AI_IMAGE_PATH}/drone.webp`,
    alt: 'Drone model',
    className: 'ai-sign-in-modal__cell--drone',
  },
  {
    name: 'tree',
    src: `${CONFERENCE_IMAGE_PATH}/tree.webp`,
    alt: 'Tree model',
    className: 'ai-sign-in-modal__cell--tree',
  },
  {
    name: 'robot',
    src: `${CONFERENCE_IMAGE_PATH}/robot.webp`,
    isTall: true,
    alt: 'Robot model',
    className: 'ai-sign-in-modal__cell--robot',
  },
  {
    name: 'chameleon',
    src: `${AI_IMAGE_PATH}/chameleon.webp`,
    alt: 'Chameleon model',
    className: 'ai-sign-in-modal__cell--chameleon',
  },
  {
    name: 'popcorn',
    src: `${CONFERENCE_IMAGE_PATH}/popcorn.webp`,
    alt: 'Popcorn model',
    className: 'ai-sign-in-modal__cell--popcorn',
  },
  {
    name: 'motorcycle',
    src: `${CONFERENCE_IMAGE_PATH}/motorcycle.webp`,
    isWide: true,
    alt: 'Motorcycle model',
    className: 'ai-sign-in-modal__cell--motorcycle',
  },
  {
    name: 'chair',
    src: `${CONFERENCE_IMAGE_PATH}/chair.webp`,
    alt: 'Chair model',
    className: 'ai-sign-in-modal__cell--chair',
  },
]
